async function devtricker_ajax_post_perform_logout() {

    const form = new FormData();

    form.append('action', 'devtricker_account_logout_action_perform_logout_ajax');
    form.append('nonce', await devtricker_ajax_get_getDevtrickerLogoutNonce());
    form.append('redirect_url', encodeURIComponent(window.location.href));

    const response = await fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        credentials: 'same-origin',
        body: form
    });

    const result = await response.json();

    if (result.success) {
        devtricker_log(null, devtricker_log_level.INFO, "Logout successful");

    } else {
        throw new Error('Failed to logout');
    }
}